/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'lodash'
import React from 'react'
// import { useTranslation } from 'react-i18next'
import combineClassNames from '../../helpers/combineClassNames'
import useStyles from './tag-selector-group-style'

const TagSelectorGroupView = ({
  options = [],
  onChange = () => {},
  value,
  maxCountDisplay = 99,
  className,
  optionClassName,
  countClassName,
  disabled = false,
}) => {
  // style
  const styles = useStyles()

  if (_.isEmpty(options)) return null

  return (
    <div
      className={combineClassNames([
        styles.container,
        className,
      ])}
    >
      {
        _.map(options, ({
          value: v,
          label,
          count,
          disabled: optionDisabled,
        }) => (
          <button
            type="button"
            key={v}
            onClick={() => onChange(v)}
            disabled={count <= 0 || disabled || optionDisabled}
            className={combineClassNames([
              styles.option,
              optionClassName,
              value === v && styles.optionActive,
            ])}
          >
            {label}
            {
              count > 0 && (
                <span
                  className={combineClassNames([
                    styles.count,
                    countClassName,
                    value === v && styles.countActive,
                  ])}
                >
                  {count > maxCountDisplay ? `${maxCountDisplay}+` : count}
                </span>
              )
            }
          </button>
        ))
      }
    </div>
  )
}

export default TagSelectorGroupView
